// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ErrorMessage_componentWrapper__8Q7r-"};